module.exports = __webpack_public_path__ + "static/media/QikberryLogo.b14b2582.png";